import { Component, OnInit, ViewChild } from '@angular/core';
import { KmsService } from 'src/app/areas/kms/kms.service';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { SwMassageBoxService } from 'src/app/librarys/serves/sw-massage-box.service';
import { SwMassageConfirmComponent } from 'src/app/librarys/components/basic-components/sw-massage-confirm/sw-massage-confirm.component';
import { KmsEnum } from 'src/app/areas/kms/serves/kms-enum';
import { SwCreateModalComponentService } from 'src/app/librarys/serves/sw-create-modal-component.service';
import { isArray } from 'util';
import { InstanceModuleService } from '../../../serves/instance/instance.module';
import { SwJwtService } from 'src/app/librarys/serves/sw-jwt.service';
declare var $, d3;
@Component({
  selector: 'app-ontology-structure-query',
  templateUrl: './ontology-structure-query.component.html',
  styleUrls: ['./ontology-structure-query.component.css']
})
export class OntologyStructureQueryComponent implements OnInit {
    // 删除确认组件
    @ViewChild("trim") trim: SwMassageConfirmComponent;

    // 定义图谱实体搜索输入数据
    searchNodeName = '';
    // 实体列表
    instanceDatasList:any = [];

    // 当前实体的关系树数据
    ontologyTree:any = [];
    // 当前实体的关系树数据是否加载中
    isRelationTreeLoading:boolean = false;
    multiNodeIds: any = [];
    // 当前选中的关系实体数据
    selectedRelationIds = [];

    // 图谱分类概念颜色
    mapColors = [
      {
          type: 'concept',
          typeName: '概念',
          bg: 'rgb(223, 114, 102)', 
          br: 'rgba(223, 114, 102, 0.6)'
      },{
          type: 'attr',
          typeName: '属性',
          bg: 'rgb(153, 100, 240)', 
          br: 'rgba(153, 100, 240, 0.6)'
      }];

    // 图谱是否显示加载中
    isLoading = false;

    // 图谱拖动状态判断
    draggedStatus = 0;

    // 判断图谱是否是初始化加载(1为初始化，2为点击拖到实体)
    initMapStatus = 1;

    // 初始化D3画布
    d3Canvas = {
        simulation: null,  // 图谱的simulation
        svg: null,  // 画布
        width: null,
        height: null,  // 画布的宽高
        marker: null,  // 图谱marker
        defs: null,  // 箭头和图片初始化
        relMap_g: null,  // 其他元素初始化
        patterns: null,  // 图片元素初始化
        edges: null,  // 线元素组合的初始化
        links: null,  // 线初始化
        rect_g: null,  // 关系容器初始化
        rects: null,  // 关系文字背景框初始化
        texts: null,  // 关系名称初始化
        circles: null,  // 实体圆初始化
        circleText: null,  // 实体圆文字初始化
        config: {  // 图谱的基本配置参数
            label_r: 25,
            active_r: 12,
            r: 8, // 头像的半径 [30 - 45]
            linkTextColor: '#676767 ', // 链接线默认的颜色
            linkColor: '#dddddd', // 链接线默认的颜色
            linkBg: '#f8f8f8',
            strokeWidth: 2, // 头像外围包裹的宽度
        },
        time: setTimeout(() => {}, 1000)  // 图谱点击时间
    }
    // 是否展示图例
    showLegend = false;
    allDatas:any = {
        nodes: [],
        relationships: []
    };
    zoom:any;
    constructor(
        private jwt: SwJwtService,
        private create:SwCreateModalComponentService,
        private kmsService: KmsService,
        private routeInfo: ActivatedRoute,
        private message: SwMassageBoxService,
        private router: Router,
        private instanModuleService: InstanceModuleService
    ) { }

    ngOnInit() {
        // 获取路由参数
        this.routeInfo.queryParams.subscribe((data: Params) => {
            this.initMap();
            // 查询概念树数据
            this.getOnlogyTreePageList();
        });
    }

    // 请求概念数据模型方法
    getOnlogyTreePageList() {
        this.isRelationTreeLoading = true;
        // this.kmsService.getConceptTreeData({}).subscribe(
        //     data => {
        //         if (data.code == 200) {
        //             this.isRelationTreeLoading = false;
        //             let res = Array.isArray(data.data) && data.data.length > 0 ? data.data : [];
        //             this.ontologyTree = res;
        //             this.selectedRelationIds = [];
        //             this.multiNodeIds = [];
        //             this.ontologyTree.forEach(element => {
        //                 this.multiNodeIds.push(element.id);
        //                 this.selectedRelationIds.push(element.id);
        //             });
        //             this.getNodeByName();
        //         }
        //     }
        // );
        this.isLoading = true;
        let kgDbInfo = this.jwt.getToken('kgDbInfo') ? JSON.parse(this.jwt.getToken('kgDbInfo')) : '';
        const modelVerId = kgDbInfo? kgDbInfo.modelVerId : '';
        this.kmsService.queryTreeListWithAttrs(modelVerId).subscribe(
          data => {
            if (data.code == 200) {
                this.isRelationTreeLoading = false;
                let res = Array.isArray(data.data) && data.data.length > 0 ? data.data : [];
                // 过滤掉根节点（模型版本节点）
                this.ontologyTree = res.filter(e => e.parentId != 'root');
                this.selectedRelationIds = [];
                this.multiNodeIds = [];
                this.ontologyTree.forEach(element => {
                    this.multiNodeIds.push(element.id);
                    this.selectedRelationIds.push(element.id);
                });
                this.getNodeByName();
            }
          }
        );
    }

    // 图谱关系树点击事件
    handleVotedClick(event) {
      // 先剔除已选关系实体中不参与查询的实体，再进行查询操作
      this.selectedRelationIds = [];
      if(event.length>0){
          event.forEach(element => {
            this.selectedRelationIds.push(element.key);
          });
      }
      this.initMapStatus = 1;
      this.isLoading = true;
      // 查询所有的概念属性关系
      this.queryOntologyStructure(true);
    }

    // 根据实体名称查询图谱数据
    getNodeByName() {
      this.initMapStatus = 1;
      this.isLoading = true;
      // 查询所有的概念属性关系
      this.queryOntologyStructure();
    };

    // 查询所有的概念属性关系
    queryOntologyStructure(isFilter?){
      // 清除图谱
      this.emptyMapDatas();
      let datas = {
        nodes: [],
        relationships: []
      };
      if(isFilter){
        let hideIds = this.ontologyTree.filter(e => !this.selectedRelationIds.includes(e.id)).map(e => e.id);
        datas.nodes = this.allDatas.nodes.filter(e => !hideIds.includes(e.id));
        datas.relationships = this.allDatas.relationships.filter(e =>!hideIds.includes(e.source) && !hideIds.includes(e.target));
        // 去掉没有关系的节点
        datas.nodes = datas.nodes.filter(e => datas.relationships.filter(f => f.source == e.id || f.target == e.id).length > 0);
      }else{
        datas = this.transformGraphData(this.ontologyTree);
        this.allDatas = datas;
      }
      let links = [];
      if(datas.relationships && datas.relationships.length>0){
          // 将links中两个节点间的关系进行标号，用于绘制曲线
          links = this.getLinkNumber(datas.relationships);
          links = links.map(d => Object.create(d));
      }
      let nodes = [];
      if(datas.nodes && datas.nodes.length>0){
          nodes = datas.nodes.map(d => Object.create(d));
      }
      this.draggedStatus = 0;
      this.showMap(nodes, links);
    }

    // 转换图谱数据
    transformGraphData(data) {
      let nodes = [];
      let relationships = [];
      // 获取节点、关系
      data.forEach(n => {
        // 概念节点
        nodes.push({
          id: n.id,
          properties: {
            nodeId: n.id,
            nodeName: n.name,
            type: 'concept',
          }
        });
        // 父子概念关系
        let p = data.find(e => e.id == n.parentId);
        if(p){
          let uuid = this.instanModuleService.uuid2();
          relationships.push({
            id: uuid,
            source: p.id,
            target: n.id,
            properties: {
              uuid: uuid,
              relationshipName: 'x包含y',
              sourceName: p.name,
              targetName: n.name
            }
          });
        }

        // 属性节点
        if(n.attrs && n.attrs.length>0){
          // 获取复合属性下的子属性
          let compoundAttrs = n.attrs.filter(e => e.isCompound);
          let compoundAttrChilds = n.attrs.filter(e => compoundAttrs.filter(f => f.id == e.parentId).length > 0);
          let oneLevelAttrs = n.attrs.filter(e => !compoundAttrChilds.includes(e));
          // 处理一级属性
          oneLevelAttrs.forEach(e => {
            // let r = nodes.find(f => f.properties.nodeName == e.name && f.properties.type == 'attr');
            // if(r){
            //   let uuid1 = this.instanModuleService.uuid2();
            //   relationships.push({
            //     id: uuid1,
            //     source: n.id,
            //     target: r.id,
            //     properties: {
            //       uuid: uuid1,
            //       relationshipName: 'x包含y',
            //       sourceName: n.name,
            //       targetName: e.name
            //     }
            //   })
            // }else{
              nodes.push({
                id: e.id,
                properties: {
                  nodeId: e.id,
                  nodeName: e.name,
                  type: 'attr',
                }
              });
              let uuid1 = this.instanModuleService.uuid2();
              relationships.push({
                id: uuid1,
                source: n.id,
                target: e.id,
                properties: {
                  uuid: uuid1,
                  relationshipName: 'x包含y',
                  sourceName: n.name,
                  targetName: e.name
                }
              })
            // }
          });

          // 处理复合属性的子属性
          compoundAttrChilds.forEach(e => {
            
          })
        }

        // 概念属性关系
        if(n.rels && n.rels.length>0){
          n.rels.forEach(e => {
            relationships.push({
              id: e.conceptRelationshipId,
              source: e.sourceConceptId,
              target: e.targetConceptId,
              properties: {
                uuid: e.conceptRelationshipId,
                relationshipName: e.relationships && e.relationships[0] ? e.relationships[0].relationName : '',
                sourceName: e.sourceConceptName,
                targetName: e.targetConceptName
              }
            })
          })
        }
      })
      return {
        nodes: nodes,
        relationships: relationships
      }
    }

    // 清空图谱数据
    emptyMapDatas() {
        d3.select('.arrows').selectAll('marker').remove();
        d3.select('.arrows').selectAll('pattern').remove();
        d3.select('.relMap_g').selectAll('g').remove();
        d3.select('.relMap_g').selectAll('circle').remove();
        d3.select('.relMap_g').selectAll('text').remove();   
        // 隐藏实体菜单和关系菜单     
        $('.nodeMenus').fadeOut();
        $('.linkMenus').fadeOut();
        // 清除推荐实体信息
        this.instanceDatasList = [];
    }

    // 初始化图谱信息
    initMap() {
        // 画布的宽高
        this.d3Canvas.width = $('#knowledgeGraph').width();
        this.d3Canvas.height = $('#knowledgeGraph').height();
        // 图谱放大缩小
        this.zoom = d3.zoom()
            .scaleExtent([1 / 2, 4])
            .on("zoom", this.zoomed);
        d3.select("#knowledgeGraph").call(this.zoom);

        // 创建画布
        this.d3Canvas.svg = d3.select("#knowledgeGraph .svg g");

        // 箭头和图像初始化
        this.d3Canvas.defs = this.d3Canvas.svg.append("defs").attr("class", "arrows");
        // 其他元素初始化
        this.d3Canvas.relMap_g = this.d3Canvas.svg.append("g").attr("class", "relMap_g");
    }

    // 显示知识图谱方法
    showMap(nodes, links) {
        let _this = this;
        _this.showLegend = true;
        let ghConfig = _this.d3Canvas.config;
        _this.d3Canvas.simulation = d3.forceSimulation(nodes)
            .force("link", d3.forceLink(links).id(d => d.id))
            .force("center", d3.forceCenter(_this.d3Canvas.width / 2, _this.d3Canvas.height / 2)) //  图谱居中
            .force("charge", d3.forceManyBody().strength(-800))
            .force("link", d3.forceLink(links).distance(180)) // 线的长度
            .force("collision", d3.forceCollide(50))
            .force("x", d3.forceX())
            .force("y", d3.forceY());
        _this.d3Canvas.marker = _this.d3Canvas.defs.selectAll(".linkMarker")
            .data(links)
            .enter()
            .append("marker")
            .attr('id', function(d){
                return "marker-"+d.properties.uuid;
            })
            .attr("markerWidth", 10) //marker视窗的宽
            .attr("markerHeight", 10) //marker视窗的高
            .attr("refX", ghConfig.r + 4 * ghConfig.strokeWidth + 2) //refX和refY，指的是图形元素和marker连接的位置坐标
            .attr("refY", 4)
            .attr("orient", "auto") //orient="auto"设置箭头的方向为自动适应线条的方向
            .attr("markerUnits", "userSpaceOnUse") //marker是否进行缩放 ,默认值是strokeWidth,会缩放
            .append("path")
            .attr("d", "M 0 0 8 4 0 8Z") //箭头的路径 从 （0,0） 到 （8,4） 到（0,8）
            .attr("fill", ghConfig.linkColor);

        // 实体名称
        _this.d3Canvas.patterns = _this.d3Canvas.defs.selectAll("pattern.patternclass")
        .data(nodes)
            .enter()
            .append("rect")
            .attr("class", function (d) {
                return 'rect' + d.id;
            })
            .attr("x", "0")
            .attr("y", function (d) {
                if (d.properties.type == 'concept') {
                    return 4 / 3 * ghConfig.active_r;
                } else {
                    return 4 / 3 * ghConfig.r;
                }
            })
            .attr("width", function (d) {
                if (d.properties.type == 'concept') {
                    return 2 * ghConfig.active_r;
                } else {
                    return 2 * ghConfig.r;
                }
            })
            .attr("height", function (d) {
                if (d.properties.type == 'concept') {
                    return 2 / 3 * ghConfig.active_r;
                } else {
                    return 2 / 3 * ghConfig.r;
                }
            })
            .attr("fill", function (d) {
                return '#fff';
            })
            .attr("opacity", function (d) {
                return 0.8;
            })
        _this.d3Canvas.patterns.append("text")
            .attr("class", function (d) {
                return 'text' + d.id;
            })
            .attr("x", function (d) {
                if (d.properties.type == 'concept') {
                    return ghConfig.active_r;
                } else {
                    return ghConfig.r;
                }
            })
            .attr("y", function (d) {
                if (d.properties.type == 'concept') {
                    return 5 / 3 * ghConfig.active_r;
                } else {
                    return 5 / 3 * ghConfig.r;
                }
            })
            .attr('text-anchor', 'middle')
            .attr("fill", function (d) {
                return '#333';
            })
            .style("font-size", function (d) {
                if (d.properties.type == 'concept') {
                    return ghConfig.active_r / 3;
                } else {
                    return ghConfig.r / 3;
                }
            })
            .text(function (d) {
                return d.properties.name;
            });
        // 每条线是个容器，有线 和一个装文字的容器
        _this.d3Canvas.edges = _this.d3Canvas.relMap_g
            .selectAll("g.edge")
            .data(links)
            .enter()
            .append("g")
            .attr("class", function (d) {
                return "edges edge" + d.id;
            })
            .attr('fill', function (d) {
                return 'transparent';
            })
            .attr("transform", function (d) {
                return _this.getTransform(d.source, d.target, _this.getDis(d.source, d.target))
            });
        // 添加线
        _this.d3Canvas.links = _this.d3Canvas.edges.append("path")
            .attr("class", "links")
            .attr("id", function(d){
                return 'links-'+d.properties.uuid
            })
            .attr("d", d => {
                const startPoint  = {x: 0, y: 0};
                const endPoint = {x: _this.getDis(d.source, d.target), y: 0};
                if(d.properties.linkIndex ==  0){
                    // 第一条连接是直线
                    return "M" + startPoint.x + "," + startPoint.y + " L" + endPoint.x + "," + endPoint.y;
                }else{
                    // 其他连接是弧线
                    const i = Math.ceil(d.properties.linkIndex / 2);
                    // 奇数、偶数 线条分别分布在上、下
                    let isEven = d.properties.linkIndex % 2 == 0 ? -1 : 1;
                    // 起始、指向节点可能是反的，所以还需要乘以seEven
                    isEven = d.properties.seEven * isEven;
                    const controlPoint1 = {
                        x: startPoint.x + (endPoint.x - startPoint.x) / 3,
                        y: startPoint.y + isEven * i * 50 // 每条弧线有不同的高度
                    };
                    
                    const controlPoint2 = {
                        x: startPoint.x + 2 * (endPoint.x - startPoint.x) / 3,
                        y: endPoint.y + isEven * i * 50 // 每条弧线有不同的高度
                    };
                    
                    // 创建贝塞尔曲线
                    return d = `M${startPoint.x},${startPoint.y} 
                            C${controlPoint1.x},${controlPoint1.y} 
                            ${controlPoint2.x},${controlPoint2.y} 
                            ${endPoint.x},${endPoint.y}`;
                }
            })
            .style("marker-end", function(d){
                return "url(#marker-"+d.properties.uuid+")";
            })
            .attr('stroke', (d) => {
                var str = d.color ? "#" + d.color : ghConfig.linkColor;
                return str;
            });

        // 添加关系文字的容器
        _this.d3Canvas.rect_g = _this.d3Canvas.edges.append("g")
            .attr("class", "rect_g")
            .style("cursor", "pointer")
            .on("click", function(d){
                const p = [d3.event.x, d3.event.y];
                if (!d3.event.defaultPrevented) {
                    // 取消上次延时未执行的方法
                    clearTimeout(_this.d3Canvas.time);
                    // 执行延时
                    _this.d3Canvas.time = setTimeout(() => {

                    }, 500);
                }
            });
        // 添加rect
        _this.d3Canvas.rects = _this.d3Canvas.rect_g.append("rect")
            .attr("y", d => {
                const startPoint  = {x: 0, y: 0};
                if(d.properties.linkIndex ==  0){
                    // 第一条连接是直线
                    return -10;
                }else{
                    //其他是弧线
                    const i = Math.ceil(d.properties.linkIndex / 2);
                    let isEven = d.properties.linkIndex % 2 == 0? -1 : 1;
                    isEven = d.properties.seEven * isEven;
                    return startPoint.y + isEven * i * 34 + isEven * (i - 1) * 5 - 10;
                }
            })
            .attr("height", 20)
            .attr("id", function(d){
                return 'linkRect-'+d.properties.uuid
            })
            .attr("fill", function (d) {
                return ghConfig.linkBg
            })
            .attr("stroke", function (d) {
                return ghConfig.linkColor
            })
            .attr('stroke-width', '1')
            .attr("rx", '10')
            .attr("ry", '15')

        // 关系名称  坐标（x,y）代表 文本的左下角的点
        _this.d3Canvas.texts = _this.d3Canvas.rect_g.append("text")
            .attr("text-anchor", "middle") // <text>文本中轴对齐方式居中  start | middle | end
            .style("font-size", 12)
            .attr("id", function(d){
                return 'linkText-'+d.properties.uuid
            })
            .text(d => {
                return d.properties.relationshipName
            })
            .attr('title', function(d){
                return d.properties.sourceName + ' '+d.properties.relationshipName + ' ' +d.properties.targetName;
            })
            .attr("fill", function (d) {
                return ghConfig.linkTextColor
            })
            .attr("x", function (d) {
                // 7.3.1 根据字的长度来更新兄弟元素 rect 的宽度
                var bbox = d3.select(this).node().getBBox();
                var width = bbox.width;
                $(this).prev('rect').attr('width', width + 10);
                // 7.3.2 更新 text 的位置
                const on = d.target.x < d.source.x ? -1 : 1;
                // 7.3.2 更新 text 的位置
                return on * _this.getDis(d.source, d.target) / 2;
            })
            .attr("y", d => {
                const startPoint  = {x: 0, y: 0};
                if(d.properties.linkIndex ==  0){
                    // 第一条连接是直线
                    return 5;
                }else{
                    //其他是弧线
                    const i = Math.ceil(d.properties.linkIndex / 2);
                    let isEven = d.properties.linkIndex % 2 == 0? -1 : 1;
                    isEven = d.properties.seEven * isEven;
                    const on = d.target.x < d.source.x? -1 : 1;
                    isEven = on * isEven;
                    return startPoint.y + isEven * i * 34 + isEven * (i - 1) * 5 + 5;
                }
            })
            .attr("transform", function (d) {
                if (d.target.x < d.source.x) {
                    return 'rotate(180)';
                } else {
                    return 'rotate(0)';
                }
            });
        this.d3Canvas.patterns = this.d3Canvas.defs
            .selectAll("pattern.patternclass")
            .data(nodes)
            .enter()
            .append("pattern")
            .attr("class", "patternclass")
            .attr("id", function(d, index) {
                return 'avatar' + d.id;
            })
            // 两个取值userSpaceOnUse  objectBoundingBox
            .attr('patternUnits', 'objectBoundingBox')
            // <pattern>，x、y值的改变决定图案的位置，宽度、高度默认为pattern图案占填充图形的百分比。
            .attr("x", "10")
            .attr("y", "10")
            .attr("width", "1")
            .attr("height", "1");
        // 关系图实体圆
        _this.d3Canvas.circles = _this.d3Canvas.relMap_g.selectAll("circle.circleclass")
            .data(nodes)
            .enter()
            .append("circle")
            .attr("class", "circles")
            .attr("id", function(d){
                return 'circles-'+d.properties.nodeId
            })
            .style("cursor", "pointer")
            .attr("fill", function (d) {
                let type = d.properties.type;
                let items = _this.mapColors.find(c => c.type == type);
                if (items) {
                    return items.bg;
                } else {
                    return '#999999';
                }
            })
            .attr("stroke", function (d) {
                let type = d.properties.type;
                let items = _this.mapColors.find(c => c.type == type);
                if (items) {
                    return items.br;
                } else {
                    return '#999999';
                }
            })
            .attr("stroke-width", function (d) {
                return '8';
            })
            .attr("r", function (d) {
                if (d.properties.type == 'concept') {
                    return ghConfig.active_r;
                } else {
                    return ghConfig.r;
                }
            })
            .attr("cx", function (d) {
                return d.x;
            })
            .attr("cy", function (d) {
                return d.y;
            })
            // 鼠标单击
            .on('click', function (d, i) {
                const p = [d3.event.x, d3.event.y];
                if (!d3.event.defaultPrevented) {
                    // 取消上次延时未执行的方法
                    clearTimeout(_this.d3Canvas.time);
                    // 执行延时
                    _this.d3Canvas.time = setTimeout(() => {
                       
                    }, 500);
                }
            })
            .call(_this.drag(_this.d3Canvas.simulation));
        _this.d3Canvas.circleText = _this.d3Canvas.relMap_g.selectAll("text.textclass")
            .data(nodes)
            .enter()
            .append("text")
            .attr('class', 'circletext')
            .attr("id", function(d){
                return 'circletext-'+d.properties.nodeId
            })
            .attr('font-size', 12)
            .style('fill', function (d) {
                return ghConfig.linkTextColor;
            })
            .attr("dominant-baseline", 'middle')
            .attr("text-anchor", "middle")//在圆圈中加上数据
            .text(function(d){
                return d.properties.nodeName.length > 10 ? d.properties.nodeName.slice(0,10)+'...' : d.properties.nodeName;
            })
            .attr("x", function (d) {
                return d.x;
            })
            .attr("y", function (d) {
                if (d.properties.type == 'concept') {
                    return d.y + 35;
                } else {
                    return d.y + 25;
                }
            })
            .style("cursor", "pointer")
            // 鼠标单击
            .on('click', function (d) {
                const p = [d3.event.x, d3.event.y];
                if (!d3.event.defaultPrevented) {
                    // 取消上次延时未执行的方法
                    clearTimeout(_this.d3Canvas.time);
                    // 执行延时
                    _this.d3Canvas.time = setTimeout(() => {
                      
                    }, 500);
                }
            });

        // 图谱显示位置
        _this.d3Canvas.simulation.on("tick", () => {
            _this.updateMapLocation();
            // if (_this.draggedStatus === 1) {
            //     _this.updateMapLocation(links);
            //     return;
            // }
            // if (_this.initMapStatus == 1) {
            //     _this.isLoading = true;
            //     if (_this.d3Canvas.simulation.alpha() <= 0.05) {
            //         _this.isLoading = false;
            //         _this.updateMapLocation(links);
            //     }
            //     _this.initMapStatus = 2;
            // } else {
            //     if (_this.d3Canvas.simulation.alpha() <= 0.05) {
            //         _this.updateMapLocation(links);
            //     }
            // }
            
        });
        // _this.d3Canvas.simulation.on("end", () => {
        //     d3.select("#knowledgeGraph").call(
        //         _this.zoom.scaleBy, 
        //         0.5, 
        //         [_this.d3Canvas.width/2, _this.d3Canvas.height/2]
        //     );
        // });
    }

    // 更新图谱位置方法
    updateMapLocation() {
        let _this = this;
        setTimeout(() => {
            _this.isLoading = false;
        },500)
        // 足够稳定时，才渲染一次
        _this.d3Canvas.rects
            .attr("x", function (d) {
                return _this.getDis(d.source, d.target) / 2 - $(this).attr('width') / 2
            }) // x 坐标为两点中心距离减去自身长度一半

        _this.d3Canvas.circles
            .attr("cx", function (d) {
                return d.x;
            })
            .attr("cy", function (d) {
                return d.y;
            })
        _this.d3Canvas.circleText
            .attr("x", function (d) {
                return d.x;
            })
            .attr("y", function (d) {
                if (d.properties.type == 'concept') {
                    return d.y + 35;
                } else {
                    return d.y + 25;
                }
            })

        _this.d3Canvas.texts
            .attr("x", function (d) {
                // 7.3.1 根据字的长度来更新兄弟元素 rect 的宽度
                var bbox = d3.select(this).node().getBBox();
                var width = bbox.width;
                $(this).prev('rect').attr('width', width + 10);
                const on = d.target.x < d.source.x ? -1 : 1;
                // 7.3.2 更新 text 的位置
                return on * _this.getDis(d.source, d.target) / 2;
            })
            .attr("y", d => {
                const startPoint  = {x: 0, y: 0};
                if(d.properties.linkIndex ==  0){
                    // 第一条连接是直线
                    return 5;
                }else{
                    //其他是弧线
                    const i = Math.ceil(d.properties.linkIndex / 2);
                    let isEven = d.properties.linkIndex % 2 == 0? -1 : 1;
                    isEven = d.properties.seEven * isEven;
                    const on = d.target.x < d.source.x? -1 : 1;
                    isEven = on * isEven;
                    return startPoint.y + isEven * i * 34 + isEven * (i - 1) * 5 + 5;
                }
            })
            .attr("transform", function (d) {
                if (d.target.x < d.source.x) {
                    return 'rotate(180)';
                } else {
                    return 'rotate(0)';
                }
            });

        _this.d3Canvas.links
            .attr("d", d => {
                const startPoint  = {x: 0, y: 0};
                const endPoint = {x: _this.getDis(d.source, d.target), y: 0};
                if(d.properties.linkIndex ==  0){
                    // 第一条连接是直线
                    return "M" + startPoint.x + "," + startPoint.y + " L" + endPoint.x + "," + endPoint.y;
                }else{
                    // 其他连接是弧线
                    const i = Math.ceil(d.properties.linkIndex / 2);
                    let isEven = d.properties.linkIndex % 2 == 0? -1 : 1;
                    isEven = d.properties.seEven * isEven;
                    const controlPoint1 = {
                        x: startPoint.x + (endPoint.x - startPoint.x) / 3,
                        y: startPoint.y + isEven * i * 50 // 每条弧线有不同的高度
                    };
                    
                    const controlPoint2 = {
                        x: startPoint.x + 2 * (endPoint.x - startPoint.x) / 3,
                        y: endPoint.y + isEven * i * 50 // 每条弧线有不同的高度
                    };
                    console.log(isEven,d.properties.linkIndex,i,controlPoint1.y);
                    
                    // 创建贝塞尔曲线
                    return d = `M${startPoint.x},${startPoint.y} 
                            C${controlPoint1.x},${controlPoint1.y} 
                            ${controlPoint2.x},${controlPoint2.y} 
                            ${endPoint.x},${endPoint.y}`;
                }
            })

        _this.d3Canvas.edges
            .attr("transform", function (d) {
                return _this.getTransform(d.source, d.target, _this.getDis(d.source, d.target))
            });
    }

    // 图谱缩放相关函数
    zoomed() {
        $('.nodeMenus').fadeOut();
        $('.linkMenus').fadeOut();
        d3.select(".svgBox").attr("transform", "translate(" + d3.event.transform.x + "," + d3.event.transform.y +
            ") scale(" + d3.event.transform.k + "," + d3.event.transform.k + ")");
    }

    // 求元素移动到目标位置所需要的 transform 属性值
    getTransform(source, target, _dis) {
        var r;
        if (target.x > source.x) {
            if (target.y > source.y) {
                r = Math.asin((target.y - source.y) / _dis)
            } else {
                r = Math.asin((source.y - target.y) / _dis);
                r = -r;
            }
        } else {
            if (target.y > source.y) {
                r = Math.asin((target.y - source.y) / _dis);
                r = Math.PI - r;
            } else {
                r = Math.asin((source.y - target.y) / _dis);
                r -= Math.PI;
            }
        }
        r = r * (180 / Math.PI);
        return "translate(" + source.x + "," + source.y + ")rotate(" + r + ")";
    }

    // 求两点间的距离
    getDis(s, t) {
        return Math.sqrt((s.x - t.x) * (s.x - t.x) + (s.y - t.y) * (s.y - t.y));
    }

    // 图谱拖拽相关函数
    drag(simulation) {
        let _this = this;
        function dragstarted(d) {
            if (!d3.event.active) simulation.alphaTarget(0.3).restart();
            d.fx = d.x;
            d.fy = d.y;
        }

        function dragged(d) {
            $('.nodeMenus').fadeOut();
            $('.linkMenus').fadeOut();
            _this.draggedStatus = 1;
            d.fx = d3.event.x;
            d.fy = d3.event.y;
        }

        function dragended(d) {
            if (!d3.event.active) simulation.alphaTarget(0);
            d.fixed = true; // 图谱线的拖动
            // d.fy = null;
        }
        return d3.drag()
            .on("start", dragstarted)
            .on("drag", dragged)
            .on("end", dragended);
    }

    getLinkNumber(links){
        // 使用Map来聚合数据，键为排序后的source和target组成的字符串
        const aggregatedMap = new Map();
        links.forEach(item => {
            // 创建一个包含source和target的数组并排序
            const keyArray = [item.source, item.target].sort((a, b) => a - b);
            // 生成排序后的键字符串
            const key = `${keyArray[0]}-${keyArray[1]}`;
            
            if (!aggregatedMap.has(key)) {
                // 如果Map中没有该键，则初始化一个新数组
                aggregatedMap.set(key, []);
            }
            // 将当前项添加到对应的聚合数组中
            const i = aggregatedMap.get(key).length;
            item.properties.linkIndex = i;
            item.properties.seEven = i == 0 || item.source == aggregatedMap.get(key)[0].source ? 1 : -1;
            aggregatedMap.get(key).push(item);
        });
        // 将Map转换为数组
        let result = [];
        const keys = Array.from(aggregatedMap.keys());
        for (const key of keys) {
            // 按linkIndex从大到小排序，绘制时两个节点的关系从外层往里层绘制，里面的关系节点名称就不会被遮挡，可以点击选中
            const arr = aggregatedMap.get(key).sort((a, b) => b.properties.linkIndex - a.properties.linkIndex);
            result = result.concat(arr);
        }
        return result;
    }
}

